import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.slice";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      visible: false,
      curStar: 'all'
    };
  },
  computed: {
    fansRanks: function fansRanks() {
      return this.$store.state.fansRanks || {};
    }
  },
  methods: {
    close: function close() {
      this.visible = false;
    },
    bindEvent: function bindEvent() {
      var _this = this;

      this.eventBus.$on('showFansListPop', function () {
        _this.initData();

        _this.visible = true;
      });
    },
    initData: function initData() {
      var _this2 = this;

      if (this.isPropsEnd) {
        this.starList.forEach(function (star) {
          if (!_this2.fansRanks[star.id]) {
            _this2.$store.dispatch('getFansRanks', star.id);
          }
        });
      }
    },
    getList: function getList(id) {
      return (this.fansRanks[id] || []).slice(0, 3);
    }
  },
  mounted: function mounted() {
    this.initData();
    this.bindEvent();
  }
};